import { Component, OnInit } from '@angular/core';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../user.service';

import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ResetData, response } from 'src/interface/user';
import { LoginComponent } from '../login/login.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

function passwordValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const password = control.value;

        if (!password) {
            return null; // Return null if the password is empty (handled by required validator)
        }

        // Define regular expressions for each requirement
        const minLength = 8;
        const uppercaseRegex = /[A-Z]/;
        const lowercaseRegex = /[a-z]/;
        const digitRegex = /\d/;
        // const specialCharacterRegex = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]/;
        const specialCharacterRegex = /[!@#$%^&*()_+{}[\]:;<>,.?~\\-]/;

        // Check if the password meets all requirements
        const isLengthValid = password.length >= minLength;
        const hasUppercase = uppercaseRegex.test(password);
        const hasLowercase = lowercaseRegex.test(password);
        const hasDigit = digitRegex.test(password);
        const hasSpecialCharacter = specialCharacterRegex.test(password);

        const isValid =
            isLengthValid &&
            hasUppercase &&
            hasLowercase &&
            hasDigit &&
            hasSpecialCharacter;

        // If any of the requirements are not met, return an error object
        if (!isValid) {
            return {
                invalidPassword: true,
            };
        }

        // If all requirements are met, return null
        return null;
    };
}

@Component({
    selector: 'app-set-new-password',
    templateUrl: './set-new-password.component.html',
    styleUrls: ['./set-new-password.component.scss'],
})
export class SetNewPasswordComponent implements OnInit {
    token: string;
    //resetPasswordForm;
    resetPasswordForm: FormGroup;
    deeplink_expired = false;
    response_data: { status?: number; message?: string };
    message: string;
    message_error: string;
    loginSuccess = false;

    constructor(
        private route: ActivatedRoute,
        private userService: UserService,
        private formBuilder: FormBuilder, // private router: Router
        private modalService: NgbModal,
        private router: Router
    ) {
        this.route.params.subscribe((params) => {
            this.token = params['token'];

            this.userService.checkDeepLinkExist(this.token).subscribe((res) => {
                this.response_data = res;
                if (this.response_data.status == 402) {
                    this.deeplink_expired = true;
                }
            });
        });
    }

    ngOnInit(): void {
        this.resetPasswordForm = this.formBuilder.group({
            newPassword: ['', [Validators.required, passwordValidator()]],
            confirmPassword: [
                '',
                [Validators.required, Validators.minLength(6)],
            ],
        });
    }

    error: string;
    async onSubmit() {
        if (this.resetPasswordForm.valid) {
            const newPasswordControl =
                this.resetPasswordForm.get('newPassword');
            const confirmPasswordControl =
                this.resetPasswordForm.get('confirmPassword');
            // const newUserNameControl = this.resetPasswordForm.get('userName');

            if (newPasswordControl && confirmPasswordControl) {
                const newPassword = newPasswordControl.value;
                const confirmPassword = confirmPasswordControl.value;

                if (newPassword === confirmPassword) {
                    const reset_data: ResetData = {
                        password: btoa(newPassword),
                        deeplinktoken: this.token,
                    };

                    this.userService
                        .saveNewpassword(reset_data)
                        .subscribe((r: response) => {
                            // Use 'response' as the type hint

                            if (r.status == 200) {
                                this.loginSuccess = true;
                                this.message = r.message;
                                this.openLoginModal();
                            } else {
                                this.loginSuccess = false;
                                this.message_error = r.message;
                            }
                        });
                } else {
                    this.message_error =
                        'New password and Reset password dosenot match';
                }
            }
        }
    }

    showNewPassword = false;
    showConfirmPassword = false;

    togglePasswordVisibility(field: string): void {
        if (field === 'newPassword') {
            this.showNewPassword = !this.showNewPassword;
        } else if (field === 'confirmPassword') {
            this.showConfirmPassword = !this.showConfirmPassword;
        }
    }
    openLoginModal() {
        const modalRef = this.modalService.open(LoginComponent);
        modalRef.componentInstance.name = 'Rv-host'; //World
    }
}
